<template>
  <v-card v-if="structuresIsLoading === false" flat>
    <dialogue-facture />
    <v-card-text>
      <v-container>
        <v-row class="mb-5">
          <v-col>
            <my-progress-bar :item="nbTotal()" />
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="(structure, i) in goodStructures()" :key="i" cols="4">
            <v-card class="mb-2 radia" @dblclick="open(structure)">
              <my-card-title
                :titre="structure.libelle"
                :sous-titre="structure.created_at"
                :color="color(structure)"
              />
              <v-card-text>
                <my-progress-bar :item="structure" />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { structureMixin } from "@/mixins/structure";
import { generalMixin } from "@/mixins/general";
import { cardMixin } from "@/mixins/cardMixin";
import { carteMixin } from "@/mixins/carte";
import dialogueFacture from "@/components/dialogueFacture";

export default {
  name: "VueShowRobStructure",
  components: {
    dialogueFacture,
  },
  mixins: [structureMixin, generalMixin, cardMixin, carteMixin],
  methods: {
    goodStructures() {
      return this.structures.filter(
        (item) => item.lignesRob.total - item.lignesRob.annule > 0
      );
    },
    nbTotal() {
      let accumulator = {
        lignesRob: {
          traite: 0,
          annule: 0,
          total: 0,
        },
      };
      const structures = this.goodStructures();
      structures.forEach(function (structure) {
        accumulator.lignesRob.traite += structure.lignesRob.traite;
        accumulator.lignesRob.annule += structure.lignesRob.annule;
        accumulator.lignesRob.total += structure.lignesRob.total;
      });
      return accumulator;
    },
    open(structure) {
      this.affichage.rob = "tab-3";
      this.paramsRob.structureId = structure.id;
      this.breadCrumbs.structure = structure.libelle;
      this.breadCrumbs.carte = null;
      this.getRobCartes({
        robId: this.paramsRob.robId,
        structureId: structure.id,
      });
    },
  },
};
</script>

<style scoped></style>
